module.exports = __webpack_public_path__ + "img/icon-car-driving.7b8c2697.png";